import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import AppointmentCategoriesContext from './context';
import CategoryIcon from '@material-ui/icons/Category';

import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import {
  showAppointmentCategories,
  editAppointmentCategories,
  newAppointmentCategories,
} from '~/config/routes';
import moment from 'moment';
import { AbilityContext } from '~/contexts/Can';

function AppointmentCategoriesList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(AppointmentCategoriesContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`appointmentCategories.attributes.${attr}`);

  function handleDeletionModal(id, title) {
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete() {
    try {
      await Request.del(`/admin/appointment_categories/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch (e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'AppointmentCategories')) {
    actions.push('new');
  }
  if(ability.can('edit', 'AppointmentCategories')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'AppointmentCategories')) {
    actions.push('del');
  }
  if(ability.can('show', 'AppointmentCategories')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={newAppointmentCategories}
        routeToEdit={editAppointmentCategories}
        routeToShow={showAppointmentCategories}
        listEl={listEl}
        path={'/admin/appointment_categories'}
        actions={actions}
        paperProps={{
          Icon: CategoryIcon,
          iconColor: 'purple',
          title: t('appointmentCategories.defPlural'),
        }}
        columns={[
          {
            title: trAttr('id'),
            field: 'id',
            type: 'numeric',
            precision: 0,
            includeThousandsSeparator: false,
          },
          { title: trAttr('name'), field: 'name', type: 'string' },
          {
            title: trAttr('created_at'),
            field: 'created_at',
            type: 'datetime',
          },
          {
            title: trAttr('updated_at'),
            field: 'updated_at',
            type: 'datetime',
          },
        ]}
        context={AppointmentCategoriesContext}
        recordMap={(record) => ({
          ...record,
          created_at: record.created_at
            ? moment(record.created_at).format('DD/MM/YYYY HH:mm')
            : null,
          updated_at: record.updated_at
            ? moment(record.updated_at).format('DD/MM/YYYY HH:mm')
            : null,
        })}
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(AppointmentCategoriesList);
